import { Injectable, Inject } from '@angular/core';
import { Meta, Title } from "@angular/platform-browser";
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { TrackingResponse } from '../interfaces/tracking-response.interface';
import { catchError } from 'rxjs/internal/operators/catchError';
declare let fbq: Function;
declare let nos: Function;
declare let ga: Function;

@Injectable()
export class SEOService {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private meta: Meta, private title: Title,
        private _http: HttpClient
    ) { }

    updateTileAndTags() {
        this.title.setTitle("");
        this.meta.addTags([
            { name: 'author', content: '' },
            { name: 'description', content: 'This page belongs to Nextsphere Titan Team. We are doning SEO Testing for now' }
        ]);
    }
    /**
     * @description Add cannonical Tag
     * @author njagadeesan
     * @date 2020-03-03
     * @param {string} url
     * @memberof SEOService
     */
    addCanonicalURL(url: string): void {
        // Remove existing canonical tag
        this.removeCanonicalTag();
        url = url || this.document.URL;
        if (url) {
            // Add canonical tag
            const linkElement = this.document.createElement('link');
            linkElement.setAttribute('href', url);
            linkElement.setAttribute('rel', 'canonical');
            this.document.head.appendChild(linkElement);
        }
    }

    /**
     * @description To remove Canonical tag
     * @author njagadeesan
     * @date 2020-03-05
     * @memberof SEOService
     */
    removeCanonicalTag(): void {
        const canonicalTag = this.document.querySelector('[rel="canonical"]');
        if (canonicalTag) {
            this.document.head.removeChild(canonicalTag);
        }
    }

    /**
    * To handle the obervable error response
    * @param  {Response|any} error
    */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error.message || error);
    }

    /**
     * @description get Distributor Tracking Details
     * @param {string} fboId
     * @returns {Observable<TrackingResponse>}
     * @memberof SEOService
     */
    getDistributorTrackingDetails(fboId: string): Observable<TrackingResponse> {
        const _url: string = ApiUrlConstants.accountApiUrl + '/distributors/' + fboId + '/social-network-configs';
        return this._http
        .get<TrackingResponse>(_url)
        .pipe(catchError(this.handleErrorObservable));
    }

    /**
     *
     * @description facebook pixel tracking tool integration
     * @param {string} facebookPixelId
     * @memberof SEOService
     */
    fbPixelIntegration(facebookPixelId: string): void {
        fbq('init', facebookPixelId);
        fbq('track', 'PageView');
        nos(facebookPixelId);
    }

    /**
     *
     * @description Google Analytics tool integration
     * @param {string} googleAnalyticsId
     * @memberof SEOService
     */
    googleAnalyticsIntegration(googleAnalyticsId: string): void {
        // gtag(window, document, 'script', 'dataLayer', googleAnalyticsId);
        ga('create', googleAnalyticsId, 'auto');
        ga('send', 'pageview');

    }

    /**
     *
     * @description will update googleAnalytics
     * @param {string} url
     * @memberof SEOService
     */
    updateGoogleAnalytics(url: string): void {
        ga('set', 'page', url);
        ga('send', 'pageview');
    }

}
